/**
 * Returns a friendly FaceScanner model label (FS2, FS3, or raw model name).
 */
export function formatFaceScannerModel(modelName, typeFallback) {
  const raw = modelName || typeFallback;
  if (!raw) return 'N/A';
  if (/FS2|FSF2/i.test(raw)) return 'FS2';
  if (/FS3|FSF3/i.test(raw)) return 'FS3';
  return raw;
}

/**
 * Label for device pickers: "ID — Name (Model)".
 */
export function formatFaceScannerDeviceLabel(device) {
  const model = formatFaceScannerModel(device.modelName, device.type);
  const name = device.name || 'Unnamed';
  return `${device.deviceID} — ${name} (${model})`;
}
